export default {
  namespaced: true,
  state: () => ({
    /**
     * Danh sách popover
     */
    popoverList: [],
  }),
  mutations: {
    /**
     * Thêm id popover vào danh sách
     * @param {*} state 
     * @param {number} popoverId Id của popover
     * @author: BMThang(02/12/2022)
     */
    addPopover: (state, popoverId) => {
      state.popoverList.push(popoverId);
    },

    /**
     * Xóa id popover và các popover ở sau khỏi danh sách
     * @param {*} state 
     * @param {number} popoverId Id của popover
     * @author: BMThang(02/12/2022)
     */
    removePopover: (state, { popoverId, isTooltip }) => {
      // Nếu là tooltip thì chỉ xóa bản thân thôi, ko xóa các popover sau
      if (isTooltip === true) {
        state.popoverList = state.popoverList.filter(currentPopover => {
          return currentPopover !== popoverId;
        });
        return;
      }
      const popoverIdx = state.popoverList.indexOf(popoverId);
      if (popoverIdx === -1) {
        return;
      }
      state.popoverList = state.popoverList.slice(0, popoverIdx);
    },
  },
}